import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/workbench'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/Login.vue'),
      meta: {
        allow: true
      }
    },
    {
      path: '/',
      name: 'authenticated',
      component: () => import('@/components/layouts/Layout.vue'),
      children: [
        {
          path: 'workbench',
          component: () => import('@/components/layouts/LayoutNote.vue'),
          children: [
            {
              name: 'workbenchNote',
              path: 'notes/:noteId',
              component: () => import('@/views/workbench/Note.vue')
            },
            {
              name: 'workbenchNotebook',
              path: 'notebooks/:notebookId',
              component: () => import('@/views/workbench/Notebook.vue'),
              children: [
                {
                  name: 'workbenchNotebookNote',
                  path: 'notes/:noteId',
                  component: () => import('@/views/workbench/Note.vue')
                }
              ]
            }
          ]
        },
        {
          name: 'settings',
          path: 'settings',
          component: () => import('@/views/settings/Settings.vue')
        }
      ]
    }
    // {
    //   path: '/desktop',
    //   component: () => import('@/views/desktop/Desktop.vue')
    // },
    // {
    //   path: '/search',
    //   component: () => import('@/views/search/Search.vue')
    // },
    // {
    //   path: '/explorer',
    //   component: () => import('@/views/explorer/Explorer.vue')
    // }
    // {
    //   path: '/recyclebin',
    //   component: () => import('@/components/layouts/LayoutNote.vue'),
    //   children: [
    //     {
    //       path: ':nodeId',
    //       component: () => import('@/views/workbench/Note.vue')
    //     }
    //   ]
    // }
  ]
})

router.beforeEach((to, from, next) => {
  const meta = to.meta
  if (meta.allow) {
    next()
    return
  }
  const authenticated = store.getters['auth/authenticated']
  if (authenticated) {
    if (to.name === 'login') {
      next('/')
      return
    }
    next()
    return
  }

  next({
    name: 'login',
    query: {
      returnUrl: to.fullPath
    }
  })
})

export default router
